import { zodSortField } from "@/lib/utils";
import { z } from "zod";

export const deleteBodyTypeSchema = z.object({
  id: z.number().int().positive(),
});

export const getBodyTypesRequestSchema = z.object({
  sort: zodSortField(["name"]),
});

export const addBodyTypeSchema = z.object({
  name: z
    .string()
    .min(1, "Le nom est requis")
    .max(200, "Maximum de caractères atteint"),
});

export const editBodyTypeSchema = z.object({
  id: z.number().optional(),
  name: z
    .string()
    .min(1, "Le nom est requis")
    .max(200, "Maximum de caractères atteint"),
  isActive: z.boolean().default(true),
});
